import { connect } from 'react-redux'
import Pupil from './pupil'
import { getProfile } from '../../../../../../../stores/profile/profile.selectors'

const mapStateToProps = state => {
  const profile = getProfile(state)
  return {
    avatarUrl: profile.avatar_url,
    name: `${profile.full_name}`,
    displayName: profile.display_name
  }
}

export default connect(mapStateToProps)(Pupil)
